// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  data_coa: yup.array().label("Account").required().min(1).of(
    yup.object().shape({
      dashboard_link_coa_id: yup.number().nullable(),
      coa_id: yup.string().label("Account").required()
    })
  )
})

export type FormType = yup.InferType<typeof validationSchema>